import { Form, Input, Select, Switch } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import Authorization from "../../../../component/Authorization";
import CustomSelect from "../../../../component/CustomSelect";
import MPageHeader from "../../../../component/PageHeader";
import { SpinContext } from "../../../../component/Spin/spin.context";
import { spinActions } from "../../../../component/Spin/spin.reducer";
import { dialog } from "../../../../helper/dialog";
import helper from "../../../../helper/helper";
import { entityService } from "../../shared/service/entity.service";
import { EntityOption } from "../../shared/shared.model";
import { Group, User, UserUI } from "../entity/user.model";
import { userService } from "../service/user.service";

const { Option } = Select;

function EditUser() {
  let { userId } = useParams();
  let navigate = useNavigate();
  const [user, setUser] = useState<UserUI>();
  const [groups, setGroups] = useState<Group[]>([]);
  const { dispatch } = useContext(SpinContext);
  const [routes, setRoutes] = useState<EntityOption[]>();
  const [form] = useForm();
  const [selectedGroup, setSelectedGroup] = useState<Group>();

  useEffect(() => {
    if (userId) {
      dispatch({ type: spinActions.BLOCK });

      userService
        .getUser(userId)
        .then((_user) => {
          setUser(_user);

          setSelectedGroup(_user.group);

          form.setFieldsValue(_user);
          dispatch({ type: spinActions.UNBLOCK });
        })
        .catch(() => {
          dispatch({ type: spinActions.UNBLOCK });
        });
    } else {
      setUser({
        username: "",
        enabled: true,
        firstName: "",
        lastName: "",
      });
    }

    userService.getGroups().then((_groups) => setGroups(_groups));

    entityService.getRoutes().then((_routes) => {
      setRoutes(_routes);
    });

    return () => {
      setUser({
        username: "",
        enabled: true,
        firstName: "",
        lastName: "",
      });
    };
  }, [userId]);

  const onFinish = async (values: any) => {
    let _user: User = {
      username: values.username,
      firstName: values.firstName,
      lastName: values.lastName,
      enabled: values.enabled,
      attributes: values.attributes,
    };

    if (values.password) {
      _user = {
        ..._user,
        credentials: [
          { type: "password", value: values.password, temporary: false },
        ],
      };
    }

    if (selectedGroup?.attributes?.routeRule == "1c") {
      let route = await userService.getUserRoute(values.username);

      _user = {
        ..._user,
        attributes: {
          routeId: route.routeId,
          roueName: route.routeName,
        },
      };
    }

    if (user?.id) {
      _user = {
        ..._user,
        id: user.id,
      };

      userService.updateUser(_user).then(() => {
        updateUserGroup(user.id!, values.group, user.group, false);
      });
    } else {
      userService.addUser(_user).then((x) => {
        userService.getUsers(_user.username).then((_users) => {
          if (_users.length > 0) {
            updateUserGroup(_users[0].id!, values.group, undefined, true);
          }
        });
      });
    }
  };

  const navigateToList = (added = false) => {
    dialog.success(
      `Хэрэглэгч амжилттай ${added ? "нэмэгдлээ" : "шинэчлэгдлээ"}.`
    );

    navigate("/users");
  };

  const updateUserGroup = (
    _userId: string,
    addingGroup: Group,
    existingGroup?: Group,
    added?: boolean
  ) => {
    if (addingGroup && addingGroup.name !== existingGroup?.name) {
      return userService
        .updatingUserGroup(_userId, addingGroup, existingGroup)
        .then(() => navigateToList(added));
    } else {
      navigateToList(added);
    }
  };

  return (
    <>
      <MPageHeader crumbs={["Хэрэглэгчид", user?.username ?? ""]} />
      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h5 className="card-title">Хэрэглэгчийн мэдээлэл</h5>
          </div>
          <div className="card-body">
            {user && (
              <fieldset
                disabled={!helper.hasRoles(["user-full", "user-manage"])}
              >
                <Form form={form} onFinish={onFinish}>
                  <div className="form-group">
                    <label>
                      Хэрэглэгчийн нэр
                      {user.id === undefined && (
                        <span className="text-danger">*</span>
                      )}
                    </label>
                    <Form.Item
                      name="username"
                      rules={[
                        {
                          required: user.id === undefined,
                          message: "Хэрэглэгчийн нэрийг оруулна уу.",
                        },
                      ]}
                    >
                      <Input
                        className="form-control"
                        readOnly={user.id !== undefined}
                      />
                    </Form.Item>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Нэр</label>
                        <span className="text-danger">*</span>
                        <Form.Item
                          name="firstName"
                          rules={[
                            {
                              required: true,
                              message: "Нэрийг оруулна уу.",
                            },
                          ]}
                        >
                          <Input className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Овог</label>
                        <span className="text-danger">*</span>
                        <Form.Item
                          name="lastName"
                          rules={[
                            {
                              required: true,
                              message: "Овогийг оруулна уу.",
                            },
                          ]}
                        >
                          <Input className="form-control" />
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Идэвхтэй эсэх</label>
                        <span className="text-danger">*</span>
                        <Form.Item name="enabled" valuePropName="checked">
                          <Switch
                            disabled={
                              !helper.hasRoles(["user-full", "user-manage"])
                            }
                          />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Ажил үүрэг
                          {user.id !== undefined && (
                            <span className="text-danger">*</span>
                          )}
                        </label>
                        <Form.Item
                          name="group"
                          rules={[
                            {
                              required: user.id !== undefined,
                              message: "Ажил үүргийг оруулна уу.",
                            },
                          ]}
                        >
                          <CustomSelect<Group>
                            options={groups}
                            onChange={(group) => {
                              setSelectedGroup(group);
                            }}
                            disabled={
                              !helper.hasRoles(["user-full", "user-manage"])
                            }
                          ></CustomSelect>
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                  {selectedGroup?.attributes?.routeRule == "multiple" && (
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label>Route</label>
                          <span className="text-danger">*</span>
                          <Form.Item name={["attributes", "routes"]}>
                            <Select
                              mode="multiple"
                              style={{ width: "100%" }}
                              placeholder="Route - үүдийг сонгоно уу."
                            >
                              {routes?.map((route) => (
                                <Option value={route.value}>
                                  {route.label}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  )}
                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Нууц үг</label>
                        <Form.Item name="password">
                          <Input.Password />
                        </Form.Item>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Нууц үг баталгаажуулах</label>
                        <Form.Item
                          name="passwordValidation"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (getFieldValue("password") === value) {
                                  return Promise.resolve();
                                }

                                return Promise.reject(
                                  new Error(
                                    "Оруулсан хоёр нууц үг хоорондоо таарахгүй байна!"
                                  )
                                );
                              },
                            }),
                          ]}
                        >
                          <Input.Password />
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <Authorization roles={["user-full", "user-manage"]}>
                    <div className="text-right">
                      <button type="submit" className="btn btn-primary">
                        Хадгалах <i className="icon-floppy-disk ml-2" />
                      </button>
                    </div>
                  </Authorization>
                </Form>
              </fieldset>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default EditUser;
